import {colors, translations} from '@/helpers/pixStatus'

export default function () {
  return {
    page: 1,
    totalPages: 0,
    perPage: 15,
    searchParams: {},
    pix: [],
    apiUrl: process.env.VUE_APP_API_URL,
    colors,
    translations,
    showPixDetails: false,
    pixDetails: null,
    fields: [
      {
        key: 'trip',
        label: 'Pedido'
      },
      {
        key: 'updatedAt',
        label: 'Data'
      },
      {
        key: 'status',
        label: 'Status'
      },
    ]
  }
}
